//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import UserInfoModule from 'app_components/modules/campus/user/userInfo'
import ActivityCalendarModule from 'app_components/modules/campus/academic/activityCalendar'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../companyDashboardSidebarModule.scss'

// @ADD Component types
interface ICompanyDashboardSidebarModuleLayoutProps {}

const CompanyDashboardSidebarModuleLayout: React.FC<ICompanyDashboardSidebarModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='company_dashboard_sidebar-component'>
      <div className="company-user-info" id="company_user_info">
        <UserInfoModule showChangePassword />
      </div>
      <div className="student-activity-calendar mt-3">
        <ActivityCalendarModule />
      </div>
    </div>
  )
}

export default CompanyDashboardSidebarModuleLayout
